import styled from 'styled-components';

export const StyledLoadingPageContainer = styled.div`
    position: absolute;
    z-index: 4;
    height: 100vh;
    width: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const StyledLoadingPageText = styled.div`
    font-size: 14px;
    margin-top: 8px;
`;